import { render, staticRenderFns } from "./coming_into_canada.vue?vue&type=template&id=1a6a8e8f&"
import script from "./coming_into_canada.vue?vue&type=script&lang=js&"
export * from "./coming_into_canada.vue?vue&type=script&lang=js&"
import style0 from "./coming_into_canada.vue?vue&type=style&index=0&id=1a6a8e8f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports